/**
 * Password Authentication Action Hooks
 *
 * High-level password authentication actions that convert Stytch responses
 * to our domain types. Return shapes are explicitly typed to avoid
 * snake_case / camelCase drift from the low-level wrappers.
 */
import { useCallback } from 'react';
import { useStytchWrappers } from './stytch-hooks';
/**
 * Hook to reset a member's password using an email reset token.
 */
export function useResetPasswordByEmail() {
    const { resetPasswordByEmail } = useStytchWrappers();
    return useCallback(async (token, password) => {
        const result = await resetPasswordByEmail(token, password);
        if (!result.success) {
            return { success: false, error: result.error };
        }
        return {
            success: true,
            memberAuthenticated: result.memberAuthenticated,
            intermediateSessionToken: result.intermediateSessionToken,
            organizationId: result.organizationId,
        };
    }, [resetPasswordByEmail]);
}
